import { useTranslation } from 'react-i18next';

/**
 * Sotto un campo di prompt, a chi NON usa l'inglese: «I prompt in inglese danno risultati migliori».
 * Scelta di Luca, L-2660 (a): l'interfaccia è nella lingua dell'utente, gli ESEMPI di prompt restano in
 * inglese (i motori — Kling, Hailuo, Veo, PixVerse — rendono meglio così), e questa riga dice perché.
 * Gli esempi che restano in inglese in ogni lingua li pretende `tools/verify-lingue.ts` (UGUALI_A_EN).
 */
export function PromptInIngleseHint() {
  const { t, i18n } = useTranslation('avatars');
  const lingua = i18n.resolvedLanguage ?? i18n.language ?? 'en';
  if (lingua.startsWith('en')) return null;
  return (
    <p className="text-[11px] text-fg-muted" data-testid="prompt-in-inglese">
      {t('prompt.englishHint')}
    </p>
  );
}
